import { useSelector } from 'react-redux';
import { IOrgChartStaff } from 'interfaces/orgchart';
import { useContext } from 'react';
import { StoreContext } from 'contexts';
import userHelper from 'helpers/user';
import { ERole } from 'constants/role';

const { permission } = userHelper;

const hasRole = (roles: string[]) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const staffOrgchart: IOrgChartStaff = useSelector(
    (state: any) => state.staff
  );
  return roles.includes(staffOrgchart.department.roleTitle);
};

const hasRoleIAM = (roles: string[]) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { currentUser } = useContext(StoreContext);
  return currentUser.roles.some(r => {
    return roles.includes(r);
  });
};

const hasPermission = (app: string, resource: string, action: string) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { currentUser } = useContext(StoreContext);
  return currentUser.permissions.includes(permission(app, resource, action));
};

const isTeamLead = () => hasRole([ERole.teamLead]);
const isSaleAdmin = () => hasRole([ERole.saleAdmin]);
const isSaleManager = () => hasRole([ERole.saleManager]);
const isAdministrator = () => hasRole([ERole.administrator]);
const isSale = () => hasRole([ERole.sale]);
const isCollaborator = () => hasRole([ERole.collaborator]);

export default {
  hasRole,
  hasRoleIAM,
  hasPermission,
  isTeamLead,
  isSaleAdmin,
  isSaleManager,
  isAdministrator,
  isSale,
  isCollaborator,
};
